import { Container, Row, Col } from "react-bootstrap";
import { BsStarFill } from "react-icons/bs";
import "./testimonials.css";

const reviews = [
  {
    quote:
      '"Since partnering with JSR DigiMarketing, we’ve seen a strong increase in website traffic, lead generation, and sales through their targeted campaigns. Their social media management built a consistent brand voice, engaging content strategy, and boosted our followers and brand awareness. Excellent communication, deep understanding of our business, and a customized approach that delivered real results."',
    name: "Anand PL",
    role: "Founder of Extraw Designs",
    avatar: "AP",
  },
  {
    quote:
      '"I’m delighted to recommend Raj from JSR DigiMarketing for his exceptional LinkedIn Profile Optimization service. His expertise, strategic approach, and attention to detail significantly enhanced my profile’s professional impact. His dedication and commitment to delivering value truly make his service outstanding."',
    name: "Jose George",
    role: "Founder of JSL Enterprises",
    avatar: "JG",
  },
  {
    quote:
      '"We are happy to have JSR DigiMarketing as our Digital Marketing Partner. Their strategic Instagram ad campaigns helped us reach the right audience, generate quality leads, and convert them into real business. Their creativity, planning, and professional approach truly stood out. We sincerely appreciate their excellent service and highly recommend them for impactful digital marketing solutions."',
    name: "Sudarsan Yedunath",
    role: "Business Development Head at Tharun’s Brainery",
    avatar: "SY",
  },
  {
    quote:
      '"I had a great experience working with Raj on my LinkedIn profile optimization. He brought clarity, structure, and a strong personal brand focus that truly elevated my presence. Highly recommend his work if you’re looking to strengthen your LinkedIn impact."',
    name: "Jaanani Gowthaman",
    role: "CA & Partner at ABKJ & Co",
    avatar: "JG",
  },
];

const Stars = () => (
  <div className="t-stars">
    {[...Array(5)].map((_, i) => (
      <BsStarFill key={i} />
    ))}
  </div>
);

export const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <Container>
        {/* Header */}
        <Row className="justify-content-center text-center">
          <Col xs={12}>
            <span className="t-badge">Testimonials</span>
            <h2 className="t-heading">
              Trusted by Growing <br /> Businesses
            </h2>
            <p className="t-sub">
              Real feedback from business owners who trust us to handle their
              digital growth, branding, and lead generation.
            </p>
          </Col>
        </Row>

        {/* Cards grid */}
        <Row className="g-4 mt-2">
          {reviews.map((r, i) => (
            <Col xs={12} md={6} key={i}>
              <div className="t-card">
                <Stars />
                <p className="t-quote">{r.quote}</p>
                <div className="t-author">
                  <div className="t-avatar">{r.avatar}</div>
                  <div>
                    <p className="t-name">{r.name}</p>
                    <p className="t-role">{r.role}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};
